import { setPubsubStream } from './../apiHelper';
import { Observable, Subscriber, concat, of } from "rxjs";
import { map, retryWhen, switchMap, share, takeUntil, finalize } from "rxjs/operators";
import { ARCObserverModel, ARCParsedData, ProcessType, ARCData } from "../../types";
import { getARCInitialData } from "../ALCInitialDataServices/ALCInitialDataServices";
import { errorHandler } from "../apiHelper";
import { getFactoryChangeObservable } from '../../Auth';
import { withLogger } from '../LogerServices';

const ARCType = ProcessType.ARC;
const ARCObserver: ARCObserverModel = {
    arcObservable: null as Observable<ARCParsedData>,
};

const parseARCData = (data: ARCData): ARCParsedData => {
    return {
        outCorrectedRatio: data.OutCorrectedRatio ? parseFloat(data.OutCorrectedRatio) : 0,
        actualDeviation: data.ActualDeviation ? parseFloat(data.ActualDeviation) : 0,
        pv1: data.Pv1 ? parseFloat(data.Pv1) : 0,
        pv2: data.Pv2 ? parseFloat(data.Pv2) : 0,
        timestamp: data.Timestamp ? parseInt(data.Timestamp) : 0,
        initialRecipeRatio: data.InitialRecipeRatio ? parseFloat(data.InitialRecipeRatio) : 0,
        solution: data.Solution,
        state: data.State,
        line: data.Line
    } as ARCParsedData
};

const setARCStream = () => new Observable<ARCData>((observer: Subscriber<any>) => {
    const close = setPubsubStream(observer, ARCType);
    return close;
}).pipe(
    retryWhen(errorHandler),
    takeUntil(getFactoryChangeObservable()),
    share()
);

const ARCDataObservable = () => {
    ARCObserver.arcObservable = concat(
        withLogger(getARCInitialData(), ARCType, {isInitial: true}).pipe(switchMap(data => of<ARCData>(...data))),
        withLogger(setARCStream(), ARCType),
    ).pipe(
        map(parseARCData),
        finalize(() => ARCObserver.arcObservable = null),
        share()
    );
    return ARCObserver.arcObservable
};

export const getARCDataObservable = (): Observable<ARCParsedData> =>
    ARCObserver.arcObservable
        ? ARCObserver.arcObservable
        : ARCDataObservable();

